import {ReceiptExpensesType} from "@/enums/type";

export class ExpensePickingListParams {
    page = 1;
    limit = 10;
    type = ReceiptExpensesType.PickingListPay;
    targetType?: number;
    targetRowGuid?: string;
    createdByRowGuid?: string;
    fromDate?: number;
    toDate?: number;
}
